// Screenname:Sub Group master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages: 
import httpbaseURL from '../common/axios';
class Subgroupservices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/SubGroupMAS/Create", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/SubGroupMAS/List")
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/SubGroupMAS/Get?id=" + doc)
    }

    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/SubGroupMAS/Update", doc)
    }
    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/SubGroupMAS/Delete?id=" + doc)
    }
    active(DelID, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "SubGroupMAS/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
}
export default new Subgroupservices()